import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-generate-invoice-pop-up',
  templateUrl: './generate-invoice-pop-up.component.html',
  styleUrls: ['./generate-invoice-pop-up.component.scss']
})
export class GenerateInvoicePopUpComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<GenerateInvoicePopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }
  save(){
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close();
  };
}
